import {Box, Grid, Typography} from "@mui/material";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import Button from "@mui/material/Button";
import React, {useState} from "react";
import t from "../../../Utils/Translation";
import {Card, Carousel, Modal} from "react-bootstrap";
import ReactPlayer from "react-player";
import {ArrowBack, ArrowForward} from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Checkbox from "@mui/material/Checkbox";
import {makeStyles, withStyles} from "@mui/styles";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles(theme => ({
    cell: {
        color: 'white'
    },
}));



const CandidatesVideo = (props) => {

    const [currentSlide, setCurrentSlide] = useState(0);
    const {candidatesResults, setCandidatesResults} = props;

    const [modal, setModal] = useState(null);

    const handleOpen = (id) => {
        setModal(id);
    };

    const handleClose = () => {
        setModal(null);
    };

    const classes = useStyles();


    const videos = [
    {
        name: "Silvia",
        src: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Silvia+Pastorino.mp4' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Silvia+Pastorino+ENG.mp4",
        preview: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Silvia.gif',
        cv: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Silvia+Pastorino.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Silvia+Pastorino+ENG+(VALUTAZIONE).pdf"
    },
    {
        name: "Bilal",
        src: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Bilab+Hakmi.mp4' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Bilal+Hakmi+ENG.mp4",
        preview: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Bilab.gif',
        cv: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Bilal+Hakmi.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Bilal+Hakmi+ENG+(VALUTAZIONE).pdf"

    },
    {
        name: "Giulia",
        src: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Giulia+Ferrari.mp4' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Giulia+Ferrari+ENG.mp4",
        preview: 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/valutazione1/Giulia.gif',
        cv: localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Giulia+Ferrari.pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Giulia+Ferrari+ENG+(VALUTAZIONE).pdf"
    },
    ];

    const numSlides = videos.length;
    const handleNext = () => {
        setCurrentSlide((currentSlide + 1) % numSlides);
    }

    const handlePrev = () => {
        setCurrentSlide((currentSlide - 1 + numSlides) % numSlides);

    }
    console.log(candidatesResults)


    const handleSelect = (selectedIndex) => {
        setCurrentSlide(selectedIndex);
    };

    const handleSubmit = () => {
        props.handleNextStep()
    }

    const handleChange = (event) => {
        const { name } = event.target;
        console.log("name", name);
        setCandidatesResults((prevState) => {
            const updatedCandidates = {...prevState};
            const [candidate, option] = name.split("-");
            updatedCandidates[candidate][option] = !updatedCandidates[candidate][option];
            console.log('prevState ', prevState)
            console.log('UpdatedCand',updatedCandidates)
            return updatedCandidates;
        });

    };

    const handleC3option2 = (event) => {
        const { name } = event.target;
        setCandidatesResults((prevState) => {
            const updatedCandidates = {...prevState};
            updatedCandidates['candidate3']['option2'] = !updatedCandidates['candidate3']['option2'];
            console.log('prevState3 ', prevState)
            console.log('UpdatedCand3',updatedCandidates)
            return updatedCandidates;
        })
    }

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance

    return (
        <div  style={{ flexGrow: 1 }}>

            <Grid container spacing={3} style={{overflowY:'scroll'}}>
                <Grid item xs={7}>
                    <Box position={'relative'} ml={2} style={{marginBottom:'2.3rem'}}>
                        <Carousel interval={null} activeIndex={currentSlide} onSelect={handleSelect} controls={false} indicators={false}>
                            {videos.map((video,caridnex) => {
                                return (
                                    <Carousel.Item key={caridnex}>
                                        <Card style={{ width: '50rem' }}>
                                            <Card.Title style={{ color: 'black', padding: '10px' }}>{video.name} </Card.Title>
                                            <Card.Img variant="top" src={video.preview}/>
                                        </Card>
                                    </Carousel.Item>
                                )
                            })}
                        </Carousel>
                        <Box display="flex" justifyContent="start" pl={6}>
                            <Button variant="primary" onClick={handleNext}>
                                <ArrowBack style={{fontSize: '50'}}/>
                            </Button>
                            <Button className={'mx-5'} onClick={() => handleOpen(currentSlide + 1)} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '15px', fontSize: '24px' }}> {t("VIEW VIDEO")}</Button>

                            <Button variant="primary" onClick={handlePrev}>
                                <ArrowForward style={{fontSize: '50'}}/>
                            </Button>
                        </Box>

                    </Box>
                </Grid>
                <Grid item xs={5}>
                    <Box height={'50vh'} display={'flex'} alignItems={'center'} justifyContent={'center'} pr={3}>
                        <Table  style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", borderRadius: 15}} >
                            <TableHead>
                                <TableRow>
                                    <TableCell> </TableCell>
                                    <TableCell className={classes.cell}>Silvia</TableCell>
                                    <TableCell className={classes.cell}>Bilal</TableCell>
                                    <TableCell className={classes.cell}>Giulia</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className={classes.cell}>                                        
                                        <Tooltip title={t("A person that keeps commitments, is reliable and trustworthy")}>
                                        <div>{t("RELIABILITY")} &nbsp; <InfoSharpIcon/></div>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Checkbox  name="candidate1-option1" checked={candidatesResults['candidate1']['option1']} onChange={handleChange} style={{color: "white"}} />
                                    </TableCell>
                                    <TableCell >
                                        <Checkbox name="candidate2-option1" checked={candidatesResults['candidate2']['option1']}  onChange={handleChange} style={{color: "white"}}/>
                                    </TableCell>
                                    <TableCell>
                                        <Checkbox name="candidate3-option1" checked={candidatesResults['candidate3']['option1']}  onChange={handleChange} style={{color: "white"}} />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.cell}>
                                        <Tooltip title={t("A teamwork oriented person, who appreciates confrontation, even with people who have different approaches or are of a different cultural background")}>
                                        <div>{"CROSSCULTURAL TEAMWORK"} &nbsp; <InfoSharpIcon/></div>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Checkbox  name="candidate1-option2"  checked={candidatesResults['candidate1']['option2']} onChange={handleChange} style={{color: "white"}}  />
                                    </TableCell>
                                    <TableCell >
                                        <Checkbox name="candidate2-option2"  checked={candidatesResults['candidate2']['option2']}  onChange={handleChange} style={{color: "white"}}/>
                                    </TableCell>
                                    <TableCell>
                                        <Checkbox name="candidate3-option2" checked={candidatesResults['candidate3']['option2']} onChange={handleChange}  style={{color: "white"}} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                    <Box px={5}>
                        <Button onClick={handleSubmit} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '15px', fontSize: '24px' }}>   {t("CLICK HERE TO CONFIRM YOUR SELECTION AND PROCEED")}</Button>
                    </Box>



                </Grid>
            </Grid>

            {modal === 1 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>Silvia Video</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <video style={{ width: '100%', height: '100%' }} src={videos[0].src} controls />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                        <div   style={{
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            <Viewer fileUrl={videos[0].cv} plugins={[defaultLayoutPluginInstance]} />;
                                        </div>
                                    </Worker>
                                </Box>

                            </Grid>
                        </Grid>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
            {modal === 2 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{videos[1].name} Video</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <video style={{ width: '100%', height: '100%' }} src={videos[1].src} controls />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                        <div   style={{
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            <Viewer fileUrl={videos[1].cv} plugins={[defaultLayoutPluginInstance]} />;
                                        </div>
                                    </Worker>
                                </Box>

                            </Grid>
                        </Grid>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
            {modal === 3 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{videos[2].name} Video</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <video style={{ width: '100%', height: '100%' }} src={videos[2].src} controls />
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <Box height={'70vh'} position={'relative'}>
                                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                        <div   style={{
                                            height: '100%',
                                            width: '100%'
                                        }}>
                                            <Viewer fileUrl={videos[2].cv} plugins={[defaultLayoutPluginInstance]} />;
                                        </div>
                                    </Worker>
                                </Box>

                            </Grid>
                        </Grid>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

        </div>
    )
};

export default CandidatesVideo;